import React from 'react';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PartnerOfferModel, buildPartnerOfferVehicleInfoPath } from 'client/data/models/partner-offer-model';
import { transformedQuestionsV2Path, MultiOfferModel } from 'client/data/models/multi-offer';
import { PageModel } from 'client/data/models/page';

import { shouldDetermineVinEligibility } from './offer-conditions-step-utils';
import { OfferConditionsStepAsync } from './offer-conditions-step-async';

export const OfferConditionsStepWrapperUI = ({
  shouldLoadOfferConditionsStep,
  conditionsQuestions,
  location,
  ...props
}) => {
  return shouldLoadOfferConditionsStep ? (
    <OfferConditionsStepAsync {...props} conditionsQuestions={conditionsQuestions} />
  ) : (
    false
  );
};

export const stateToPropsConfig = {
  conditionsQuestions: bindToPath(() => transformedQuestionsV2Path.build(), MultiOfferModel),
  vehicleInfo: bindToPath(
    ({ vehicle: { make, model, year }, vin, modsId, isStepActive, predefinedVin, isVinFromDrawer, activeStepId }) =>
      isStepActive || shouldDetermineVinEligibility(make, model, year, predefinedVin, isVinFromDrawer, activeStepId)
        ? buildPartnerOfferVehicleInfoPath({
            vin: vin || predefinedVin,
            modsId,
          })
        : null,
    PartnerOfferModel
  ),
  location: bindToPath('location', PageModel),
};

export const OfferConditionsStepWrapper = connectToModel(OfferConditionsStepWrapperUI, stateToPropsConfig);
